import { Player } from "./player.model"

export class Position {
    player_id?: Player = new Player()
    generalPosition: string = ''
    specificPosition: string = ''
    starterPositionId: number = -1
    x?: string
    y?: string
    player?: Player
    sub?: string
    subPlayer?: Player
}

const lineup3421:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFD', x:'80%', y:'70%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'50%', y:'70%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'DFI', x:'20%', y:'70%'},
    {starterPositionId:4, generalPosition:'DEF', specificPosition:'CAD', x:'3%', y:'45%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'CAI', x:'97%', y:'45%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'62%', y:'48%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MC', x:'38%', y:'48%'},
    {starterPositionId:8, generalPosition:'DEL', specificPosition:'MPI', x:'25%', y:'25%'},
    {starterPositionId:9, generalPosition:'DEL', specificPosition:'MPD', x:'75%', y:'25%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'50%', y:'15%'}
]
  
const lineup442:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFC', x:'65%', y:'70%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'35%', y:'70%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'LI', x:'8%', y:'68%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'LD', x:'92%', y:'68%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'65%', y:'45%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MC', x:'35%', y:'45%'},
    {starterPositionId:4, generalPosition:'MED', specificPosition:'MI', x:'8%', y:'42%'},
    {starterPositionId:8, generalPosition:'MED', specificPosition:'MD', x:'92%', y:'42%'},
    {starterPositionId:9, generalPosition:'DEL', specificPosition:'DC', x:'35%', y:'18%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'65%', y:'18%'},
]

const lineup352:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFD', x:'80%', y:'70%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'50%', y:'70%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'DFI', x:'20%', y:'70%'},
    {starterPositionId:4, generalPosition:'DEF', specificPosition:'CAI', x:'3%', y:'42%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'CAD', x:'97%', y:'42%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MCD', x:'50%', y:'48%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'73%', y:'45%'},
    {starterPositionId:8, generalPosition:'MED', specificPosition:'MC', x:'27%', y:'45%'},
    {starterPositionId:9, generalPosition:'DEL', specificPosition:'DC', x:'35%', y:'18%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'65%', y:'18%'},
]

const lineup532:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFD', x:'75%', y:'70%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'50%', y:'70%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'DFI', x:'25%', y:'70%'},
    {starterPositionId:4, generalPosition:'DEF', specificPosition:'CAI', x:'3%', y:'60%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'CAD', x:'97%', y:'60%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MCD', x:'50%', y:'48%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'75%', y:'45%'},
    {starterPositionId:8, generalPosition:'MED', specificPosition:'MC', x:'25%', y:'45%'},
    {starterPositionId:9, generalPosition:'DEL', specificPosition:'DC', x:'35%', y:'20%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'65%', y:'20%'},
]

const lineup541:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFD', x:'75%', y:'70%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'50%', y:'70%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'DFI', x:'25%', y:'70%'},
    {starterPositionId:4, generalPosition:'DEF', specificPosition:'CAI', x:'3%', y:'60%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'CAD', x:'97%', y:'60%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'62%', y:'45%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MC', x:'38%', y:'45%'},
    {starterPositionId:8, generalPosition:'MED', specificPosition:'MI', x:'10%', y:'40%'},
    {starterPositionId:9, generalPosition:'MED', specificPosition:'MD', x:'90%', y:'40%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'50%', y:'15%'}
]

const lineup4231:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFC', x:'67%', y:'75%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'33%', y:'75%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'LI', x:'8%', y:'68%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'LD', x:'92%', y:'68%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'65%', y:'55%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MC', x:'35%', y:'55%'},
    {starterPositionId:4, generalPosition:'DEL', specificPosition:'EI', x:'8%', y:'32%'},
    {starterPositionId:8, generalPosition:'DEL', specificPosition:'ED', x:'92%', y:'32%'},
    {starterPositionId:9, generalPosition:'DEL', specificPosition:'MCO', x:'50%', y:'35%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'50%', y:'15%'},
]

const lineup433:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFC', x:'67%', y:'72%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'33%', y:'72%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'LI', x:'8%', y:'68%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'LD', x:'92%', y:'68%'},
    {starterPositionId:9, generalPosition:'MED', specificPosition:'MCD', x:'50%', y:'50%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'75%', y:'45%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MC', x:'25%', y:'45%'},
    {starterPositionId:4, generalPosition:'DEL', specificPosition:'EI', x:'12%', y:'25%'},
    {starterPositionId:8, generalPosition:'DEL', specificPosition:'ED', x:'88%', y:'25%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'50%', y:'15%'},
]

const lineup4141:Position[]=[
    {starterPositionId:0, generalPosition:'POR', specificPosition:'POR', x:'50%', y:'90%'},
    {starterPositionId:1, generalPosition:'DEF', specificPosition:'DFC', x:'67%', y:'72%'},
    {starterPositionId:2, generalPosition:'DEF', specificPosition:'DFC', x:'33%', y:'72%'},
    {starterPositionId:3, generalPosition:'DEF', specificPosition:'LI', x:'8%', y:'68%'},
    {starterPositionId:5, generalPosition:'DEF', specificPosition:'LD', x:'92%', y:'68%'},
    {starterPositionId:9, generalPosition:'MED', specificPosition:'MCD', x:'50%', y:'50%'},
    {starterPositionId:6, generalPosition:'MED', specificPosition:'MC', x:'72%', y:'35%'},
    {starterPositionId:7, generalPosition:'MED', specificPosition:'MC', x:'28%', y:'35%'},
    {starterPositionId:4, generalPosition:'DEL', specificPosition:'EI', x:'5%', y:'30%'},
    {starterPositionId:8, generalPosition:'DEL', specificPosition:'ED', x:'95%', y:'30%'},
    {starterPositionId:10, generalPosition:'DEL', specificPosition:'DC', x:'50%', y:'15%'},
]

export const lineups = {
    '3-4-2-1': lineup3421,
    '4-4-2': lineup442,
    '3-5-2': lineup352,
    '5-4-1': lineup541,
    '4-2-3-1': lineup4231,
    '4-3-3': lineup433,
    '5-3-2': lineup532,
    '4-1-4-1': lineup4141,
}